import React from 'react';
const Icon = (props) => {
    const icon = `${props.family}-${props.name}${props.inverted ? '-white' : ''}`;
    return React.createElement("span", { "aria-label": props.ariaLabel, "aria-hidden": true, className: `icon icon--${icon} ${props.autoSize ? 'auto-size' : ''}` });
};
Icon.defaultProps = {
    family: '10',
    inverted: false,
    ariaHidden: false,
};
export default Icon;
